import ThreeJsContainer from './ThreeJsContainer';

export default ThreeJsContainer;
